
import { OptionMenu } from "../prm/option-menu";
import { Name } from "../prm/name";
import UGMA_state_age from "../../lib/UGMA_age_data.json";
import { sprintf } from "sprintf-js";
import UGMA_state_age2 from "../../lib/UGMA_age_data_2.json";

class UgmaStateMenu extends OptionMenu {

  constructor(name) {
    super(name);

    const states = Object.keys(UGMA_state_age).sort();
    this.menu = states.map(state => new Name(state, state));
    this.onChangeCallback = this.updateAgeMenu;
  }

  setOnChangeCallback = callback => {
    this.otherCallback = callback;
  };

  setAgeMenu = option_menu => {
    this.ageMenu = option_menu;
  };

  randomStateMenu(state) {
    this.setRandomValue(state);
    this.updateAgeMenu(null, state);
    this.ageMenu.setRandomValue(state);
  }

  updateAgeMenu = (component, newState) => {
    const state = this.getValue(newState).id;
    const data = UGMA_state_age[state];
    const invalid = data.age_from === -1 && data.age_to === -1;
    const values = [];
    if (!invalid) {
      for(let i=data.age_from; i <= data.age_to; i++) {
        values.push(sprintf("%d", i));
      }
    }

    if (invalid) {
      if (this.ageMenu.menu.length === 1
        && this.ageMenu.menu[0].id === "na") {
        // Menu is already set to invalid.
        return;
      }
      this.ageMenu.menu = [ new Name("na", "N/A")];
      this.ageMenu.setValue(newState, 0);
    } else {
      if (JSON.stringify(values) === JSON.stringify(
          this.ageMenu.menu.map(name => name.id))) {
        return;
      }
      this.ageMenu.menu = values.map(num => new Name(num, num));
      this.ageMenu.setValue(newState, 0);

    }

    if (component) {
      this.otherCallback(component, newState);
    }
  }
}

class UGMAStateMenu2 extends OptionMenu {

  constructor(name) {
    super(name);

    const states = Object.keys(UGMA_state_age2).sort();
    this.menu = states.map(state => new Name(state, state));
  }

  getAge = state => {
    const name = this.getValue(state);
    if (!name) {
      return null;
    }

    const state_id = name.id;
    if (!(state_id in UGMA_state_age2)) {
      return null;
    }

    return UGMA_state_age2[state_id].age;
  }
}


export { UgmaStateMenu, UGMAStateMenu2 };
